import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const Anchor = styled('div', {
  base: {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: '95',
    pointerEvents: 'none',
  },
})

const ToastCard = styled(motion.div, {
  base: {
    pointerEvents: 'auto',
    minWidth: '280px',
    maxWidth: '360px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'md',
    boxShadow: '0 24px 48px -16px rgba(26, 19, 48, 0.32)',
    padding: '14px 16px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    border: '1.5px solid',
    borderColor: 'quickpass.primarySoft',
  },
})

const Glyph = styled('span', {
  base: {
    width: '40px',
    height: '40px',
    borderRadius: 'pill',
    backgroundColor: 'quickpass.surfaceCool',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    flexShrink: '0',
  },
})

const Body = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    flex: '1',
    minWidth: '0',
  },
})

const Eyebrow = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: 'quickpass.primary',
  },
})

const Title = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const Blurb = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.4',
  },
})

const DismissButton = styled('button', {
  base: {
    width: '24px',
    height: '24px',
    borderRadius: 'pill',
    border: 'none',
    backgroundColor: 'quickpass.surfaceCool',
    color: 'quickpass.inkSoft',
    fontSize: '14px',
    lineHeight: '1',
    cursor: 'pointer',
    flexShrink: '0',
    transition:
      'background-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}',
    _hover: {
      backgroundColor: 'quickpass.warmth',
      color: '#FFFFFF',
    },
  },
})

export { Anchor, ToastCard, Glyph, Body, Eyebrow, Title, Blurb, DismissButton }
